/* original - assumed USD formatting
export default {
  // Format price to have 2 decimal places, prepend $, and add commas
  // NOTE: This function expects Shopify price format, so if shopifyPrice = 1000, then it will return $10
  formatPrice (shopifyPrice) {
    return `$${(parseInt(shopifyPrice) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`
  }
}
*/

/* global.js version
In front-end liquid code, add data attribute to span/div/whatever that holds the price. A listener in global.js then
uses the same Intl.NumberFormat function as below to format prices. Did this so the formats match.
E.g.  data-shopify-price="{{ product.price }}"
Variants e.g. data-variant-shopify-price="{{ all_products[handle].price }}"
*/

/*
There are some stray artefacts from originally determining currency by language instead of by country.
*/

// Determine US vs UK - og and paypal currencies are the long way around to get this to work in dev environments
// not sure if paypal is always availale, og only available on PDPs
const country = window.localeInformation.country.toLowerCase()
const language = window.localeInformation.language
let enLocale = 'en-US'
let enCurrency = 'USD'
let caLocale = 'en-CA'
let frLocale = 'fr-FR'
let frCurrency = 'EUR'
let esLocale = 'es-ES'
let esCurrency = 'EUR'
const ogCurrency = document.querySelector('meta[property~="og:price:currency"][content]') ? document.querySelector('meta[property~="og:price:currency"][content]').content : ''
const paypalCurrency = document.getElementById('in-context-paypal-metadata') ? document.getElementById('in-context-paypal-metadata').dataset.currency.value : ''
if (window.location.host.includes('international') || paypalCurrency === 'GPB' || ogCurrency === 'GBP') {
  enLocale = 'en-GB'
  enCurrency = 'GBP'
} else if (window.localeInformation.market === 'canada' || window.localeInformation.currency === 'CAD' || paypalCurrency === 'CAD' || ogCurrency === 'CAD') {
  if (language === 'fr') {
    caLocale = 'fr-CA'
    frLocale = 'fr-CA'
  } else if (language === 'en') {
    enLocale = 'en-CA'
  }
} else if (window.localeInformation.market === 'us' || window.localeInformation.currency === 'USD' || paypalCurrency === 'USD' || ogCurrency === 'USD') {
  esLocale = 'es-US'
  esCurrency = 'USD'
  frLocale = 'fr-US'
  frCurrency = 'USD'
}

const currencyDefaults = {
  us: enCurrency,
  ca: 'CAD',
  dk: 'DKK',
  de: 'EUR',
  es: esCurrency,
  fr: frCurrency,
  gb: enCurrency,
  nl: 'EUR',
  no: 'NOK',
  se: 'SEK'
}
const currency = currencyDefaults[country]

// not sure if es and fr are correct
const fullyQualifiedLocaleDefaults = {
  us: enLocale,
  ca: caLocale,
  dk: 'da-DK',
  de: 'de-DE',
  es: esLocale,
  fr: frLocale,
  gb: enLocale,
  nl: 'nl-NL',
  no: 'nb-NO',
  se: 'sv-SE'
}

export default {
  formatPrice (shopifyPrice, withCurrency = true) {
    // NOTE: This function expects Shopify price format, so if shopifyPrice = 1000, then it will return $10
    let returnPrice = new Intl.NumberFormat(fullyQualifiedLocaleDefaults[country], { style: 'currency', currency }).format(shopifyPrice / 100)

    let currencyCode = ''
    if (withCurrency === true && window.localeInformation.market === 'canada') {
      currencyCode = currency
    }

    if (currencyCode && language === 'en') {
      returnPrice = currencyCode + returnPrice
    } else if (currencyCode && language === 'fr') {
      returnPrice = returnPrice + currencyCode
    }

    return returnPrice
  }
}
